export interface RoleModel {
  id?: number;
  name: string;
  permissions: string;
  status?: number;
}


export const RoleValues = (data?: RoleModel) => {
  return {
    name: data?.name ?? '',
    permissions: data?.permissions ? data.permissions.split(",") : [],
  }
}